/** The texts of the uploads page, its jobs and the uploads dock (ANON-*, UPL-*), spread into the app's dictionaries (`lib/i18n.tsx`). */
export const uploadsEn = {
  uploads: 'Uploads',
  uploadsIntro: 'Uploads run in this tab while you work anywhere in the platform. Drop folders, files or ZIP archives on any page to add one.',
  noUploadJobs: 'No uploads in this tab yet. Choose or drop files, folders or ZIP archives to start one.',
  noFilesFound: 'No files were found in what you chose.',
  jobMore: '{name} and {count} more',
  jobsWorking: 'At work',
  jobsWaiting: 'Waiting for you',
  jobsQueued: 'Queued or paused',
  jobsDone: 'Done in this tab',
  uploadsEarlier: 'Earlier uploads',
  uploadsShowEarlier: 'Show earlier uploads',
  rejectedFiles: 'Rejected files, by reason',
  phase_new: 'Waiting to be checked',
  phase_needsToken: 'Needs the site token',
  phase_failed: 'Stopped by an error',
  phase_checking: 'Checking',
  phase_checked: 'Checked, waiting for you',
  phase_queued: 'Queued',
  phase_uploading: 'Uploading',
  phase_paused: 'Paused',
  phase_finishing: 'The platform checks the files',
  phase_done: 'Done',
  fileCount: '{count} files',
  fileCount_one: '1 file',
  patientCount: '{count} patients',
  patientCount_one: '1 patient',
  progressOf: '{done} of {of}',
  checkAgain: 'Check again',
  removeJob: 'Remove from the list',
  outcome_uploaded: 'Uploaded',
  outcome_progress: 'In progress',
  outcome_ready: 'Ready',
  outcome_unchecked: 'Not checked yet',
  outcome_needs: 'Needs you',
  outcome_failed: 'Failed',
  outcome_leftout: 'Left out',
  outcome_already: 'Already there',
  outcomeHint_needs: 'Correct them here, and they are checked again.',
  outcomeHint_failed: 'Look into these files.',
  outcomeHint_leftout: 'Nothing to do: not for the platform.',
  outcomeHint_already: 'Nothing to do: on the platform already.',
  filesByOutcome: 'Files by outcome',
  stage_check: 'Checked here',
  stage_anonymize: 'Anonymized here',
  stage_send: 'Sent',
  stage_platform: 'Checked by the platform',
  paceFiles: '{rate} files/s',
  paceBits: '{rate} Mbit/s',
  minutesLeft: 'about {count} minutes left',
  minutesLeft_one: 'about 1 minute left',
  underAMinuteLeft: 'less than a minute left',
  paceNetwork: 'The network sets the pace: anonymized files wait to be sent.',
  engines: 'Engines',
  enginesOf: '{count} of {max}',
  enginesHint: 'Each engine anonymizes on one processor core. More engines are faster and need more memory.',
  runsInBackground: 'Runs in this tab while you work elsewhere. Closing the tab pauses it; choose the same files again to resume.',
  whyNotUploaded: 'Why files are not uploaded',
  nothingHeldBack: 'No file is held back.',
  showFiles: 'Show files',
  hideFiles: 'Hide files',
  correctFiles: 'Correct',
  correctionFor: 'For the {count} files ticked below',
  correctionFor_one: 'For the file ticked below',
  labelMappingIntro:
    'Each kind becomes a catalog label of its shape type, a free-text class under its old name, or nothing. No label joins the catalog here: propose a missing one to the catalog editors.',
  foreignLabel: 'In the files',
  foreignBecomes: 'Becomes',
  foreignBecomesFor: 'What {label} becomes',
  foreignAnnotations: '{count} annotations',
  foreignAnnotations_one: '1 annotation',
  foreignFiles: 'in {count} files',
  foreignFiles_one: 'in 1 file',
  chooseTarget: 'Choose…',
  mapToFreeText: 'Free-text class {label}',
  mapToNothing: 'Leave out',
  selectFile: 'Select {name}',
  moreFiles: 'and {count} more',
  saveList: 'Save the list (CSV)',
  filesIn: '{outcome}: {count}',
  itemStatus_processing: 'In an engine',
  itemStatus_anonymized: 'Anonymized, waits to be sent',
  itemStatus_transferring: 'Being sent',
  itemStatus_pending: 'Being sent',
  itemStatus_uploaded: 'Sent, the platform checks it',
  itemStatus_validating: 'The platform checks it',
  itemStatus_waiting: 'Waiting',
  itemStatus_accepted: 'Accepted',
  queuedNote: 'It starts once the upload before it has sent its files.',
  why_sent_before: 'Uploaded before from this browser: not read or sent again.',
  why_duplicate: 'The platform holds this image already and did not store it twice.',
  uploadsDock: 'Uploads',
  foldUploads: 'Fold the uploads panel',
  openUploads: 'Open the uploads panel, {percent} %',
  allUploads: 'All uploads',
  needYou: '{count} need you',
  needYou_one: '1 needs you',
  confirmToStart: 'Confirm to start',
}

export const uploadsDe: Record<keyof typeof uploadsEn, string> = {
  uploads: 'Uploads',
  uploadsIntro:
    'Uploads laufen in diesem Tab, während Sie überall auf der Plattform weiterarbeiten. Ziehen Sie Ordner, Dateien oder ZIP-Archive auf eine beliebige Seite, um einen zu beginnen.',
  noUploadJobs: 'Noch keine Uploads in diesem Tab. Wählen oder ziehen Sie Dateien, Ordner oder ZIP-Archive hierher, um einen zu beginnen.',
  noFilesFound: 'In der Auswahl wurden keine Dateien gefunden.',
  jobMore: '{name} und {count} weitere',
  jobsWorking: 'In Arbeit',
  jobsWaiting: 'Wartet auf Sie',
  jobsQueued: 'Eingereiht oder pausiert',
  jobsDone: 'In diesem Tab erledigt',
  uploadsEarlier: 'Frühere Uploads',
  uploadsShowEarlier: 'Frühere Uploads zeigen',
  rejectedFiles: 'Abgelehnte Dateien, nach Grund',
  phase_new: 'Wartet auf die Prüfung',
  phase_needsToken: 'Braucht das Token des Standorts',
  phase_failed: 'Durch einen Fehler angehalten',
  phase_checking: 'Wird geprüft',
  phase_checked: 'Geprüft, wartet auf Sie',
  phase_queued: 'Eingereiht',
  phase_uploading: 'Wird hochgeladen',
  phase_paused: 'Pausiert',
  phase_finishing: 'Die Plattform prüft die Dateien',
  phase_done: 'Erledigt',
  fileCount: '{count} Dateien',
  fileCount_one: '1 Datei',
  patientCount: '{count} Patienten',
  patientCount_one: '1 Patient',
  progressOf: '{done} von {of}',
  checkAgain: 'Erneut prüfen',
  removeJob: 'Aus der Liste entfernen',
  outcome_uploaded: 'Hochgeladen',
  outcome_progress: 'In Arbeit',
  outcome_ready: 'Bereit',
  outcome_unchecked: 'Noch nicht geprüft',
  outcome_needs: 'Braucht Sie',
  outcome_failed: 'Fehlgeschlagen',
  outcome_leftout: 'Ausgelassen',
  outcome_already: 'Schon vorhanden',
  outcomeHint_needs: 'Korrigieren Sie sie hier, dann werden sie erneut geprüft.',
  outcomeHint_failed: 'Sehen Sie sich diese Dateien an.',
  outcomeHint_leftout: 'Nichts zu tun: nicht für die Plattform.',
  outcomeHint_already: 'Nichts zu tun: schon auf der Plattform.',
  filesByOutcome: 'Dateien nach Ergebnis',
  stage_check: 'Hier geprüft',
  stage_anonymize: 'Hier anonymisiert',
  stage_send: 'Gesendet',
  stage_platform: 'Von der Plattform geprüft',
  paceFiles: '{rate} Dateien/s',
  paceBits: '{rate} Mbit/s',
  minutesLeft: 'noch etwa {count} Minuten',
  minutesLeft_one: 'noch etwa 1 Minute',
  underAMinuteLeft: 'noch weniger als eine Minute',
  paceNetwork: 'Das Netzwerk bestimmt das Tempo: Anonymisierte Dateien warten auf das Senden.',
  engines: 'Engines',
  enginesOf: '{count} von {max}',
  enginesHint: 'Jede Engine anonymisiert auf einem Prozessorkern. Mehr Engines sind schneller und brauchen mehr Speicher.',
  runsInBackground:
    'Läuft in diesem Tab, während Sie anderswo arbeiten. Schließen des Tabs pausiert den Upload; wählen Sie dieselben Dateien erneut, um fortzusetzen.',
  whyNotUploaded: 'Warum Dateien nicht hochgeladen werden',
  nothingHeldBack: 'Keine Datei wird zurückgehalten.',
  showFiles: 'Dateien zeigen',
  hideFiles: 'Dateien ausblenden',
  correctFiles: 'Korrigieren',
  correctionFor: 'Für die {count} unten angehakten Dateien',
  correctionFor_one: 'Für die unten angehakte Datei',
  labelMappingIntro:
    'Jede Art wird zu einem Katalog-Label ihres Formtyps, zu einer Freitext-Klasse mit ihrem alten Namen oder zu nichts. Hier kommt kein Label in den Katalog: Schlagen Sie ein fehlendes der Katalog-Redaktion vor.',
  foreignLabel: 'In den Dateien',
  foreignBecomes: 'Wird zu',
  foreignBecomesFor: 'Wozu {label} wird',
  foreignAnnotations: '{count} Annotationen',
  foreignAnnotations_one: '1 Annotation',
  foreignFiles: 'in {count} Dateien',
  foreignFiles_one: 'in 1 Datei',
  chooseTarget: 'Wählen…',
  mapToFreeText: 'Freitext-Klasse {label}',
  mapToNothing: 'Weglassen',
  selectFile: '{name} auswählen',
  moreFiles: 'und {count} weitere',
  saveList: 'Liste speichern (CSV)',
  filesIn: '{outcome}: {count}',
  itemStatus_processing: 'In einer Engine',
  itemStatus_anonymized: 'Anonymisiert, wartet auf das Senden',
  itemStatus_transferring: 'Wird gesendet',
  itemStatus_pending: 'Wird gesendet',
  itemStatus_uploaded: 'Gesendet, die Plattform prüft sie',
  itemStatus_validating: 'Die Plattform prüft sie',
  itemStatus_waiting: 'Wartet',
  itemStatus_accepted: 'Angenommen',
  queuedNote: 'Er beginnt, sobald der Upload davor seine Dateien gesendet hat.',
  why_sent_before: 'Schon aus diesem Browser hochgeladen: nicht erneut gelesen oder gesendet.',
  why_duplicate: 'Die Plattform hat dieses Bild schon und hat es nicht doppelt gespeichert.',
  uploadsDock: 'Uploads',
  foldUploads: 'Upload-Bereich einklappen',
  openUploads: 'Upload-Bereich öffnen, {percent} %',
  allUploads: 'Alle Uploads',
  needYou: '{count} brauchen Sie',
  needYou_one: '1 braucht Sie',
  confirmToStart: 'Zum Start bestätigen',
}
